export const BUILD_VERSION = '1792511092';
